import type { Capability } from '../Capability';

// dummy capability, the code handles both single and multiple prefixes just fine
export const MultiPrefixCapability: Capability = {
	name: 'multi-prefix'
};
